import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

export type VideoButtonSize = 'small' | 'big'

export interface VideoButtonProps {
  additionalClassName?: string
  onClick: () => void
  size?: VideoButtonSize
  title: string
}

export const VideoButton = ({
  additionalClassName,
  children,
  onClick: onClickCallback,
  size = 'small',
  title,
}: PropsWithChildren<VideoButtonProps>) => {
  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onClickCallback?.()
  }

  return (
    <button
      className={classNames(
        'inline-flex justify-center items-center p-10 text-neutral rounded bg-shade-lightest-warm/20 transition-hover',
        'hover:bg-neutral-contrast/10 focus:outline-1 focus:outline-current focus:outline',
        {
          'w-45 h-45': size === 'small',
          'w-60 h-60': size === 'big',
        },
        additionalClassName
      )}
      onClick={onClick}
      title={title}
    >
      {children}
    </button>
  )
}
